
// constants as defined in RevoXef’s App\Models\Config\OrderConfig
const CHANGE_ALERT_NEVER = 0
const CHANGE_ALERT_ALWAYS = 1
const CHANGE_ALERT_AUTO = 2

const GROUP_ITEMS_NEVER = 0
const GROUP_ITEMS_ALWAYS = 1
const GROUP_ITEMS_EXCEPT_SAME_EMPLOYEE = 2

const ASK_GUESTS_NO = 0
const ASK_GUESTS_YES = 1
const ASK_GUESTS_USE_MENUS = 2
const ASK_GUESTS_IN_TPV_TOO = 3

const getters = {
  get: (state, getters, rootState) => key => rootState.rummage.data.OrderConfig?.[0]?.[key],

  alwaysChangeAlert: (state, getters) => getters['get']('shouldShowChangeAlert') == CHANGE_ALERT_ALWAYS,
  autoChangeAlert: (state, getters) => getters['get']('shouldShowChangeAlert') == CHANGE_ALERT_AUTO,

  neverStackItems: (state, getters) => getters['get']('shouldStackSameItems') == GROUP_ITEMS_NEVER,
  shouldStackItemsSameEmployee: (state, getters) => getters['get']('shouldStackSameItems') == GROUP_ITEMS_EXCEPT_SAME_EMPLOYEE,

  // from Xef’s Taste\Models\Configuration\GSOrderConfig.m
  shouldAskGuestsForTable: (state, getters) => [ASK_GUESTS_YES, ASK_GUESTS_IN_TPV_TOO].indexOf(getters['get']('shouldAskGuests')) !== -1,
  // shouldAskGuestsForTPV: (state, getters) => getters['get']('shouldAskGuests') == ASK_GUESTS_IN_TPV_TOO,

  pinLength: (state, getters) => parseInt(getters['get']('pinLength')) || 4
}

export default {
  namespaced: true,
  getters,
}
